import { render, staticRenderFns } from "./Impuesto.vue?vue&type=template&id=296b7714&scoped=true"
import script from "./Impuesto.vue?vue&type=script&lang=js"
export * from "./Impuesto.vue?vue&type=script&lang=js"
import style0 from "./Impuesto.vue?vue&type=style&index=0&id=296b7714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296b7714",
  null
  
)

export default component.exports